/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerFindAllQueryResponse, TemplatesControllerFindAllQueryParams, TemplatesControllerFindAll401, TemplatesControllerFindAll403 } from "../../models/checklistsController/TemplatesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templatesControllerFindAll } from "../../clients/checklistsService/templatesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templatesControllerFindAllQueryKey = (params: TemplatesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-templates'
}, ...(params ? [params] : [])] as const;
export type TemplatesControllerFindAllQueryKey = ReturnType<typeof templatesControllerFindAllQueryKey>;
export function templatesControllerFindAllQueryOptions(params?: TemplatesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templatesControllerFindAllQueryKey(params);
  return queryOptions<TemplatesControllerFindAllQueryResponse, ResponseErrorConfig<TemplatesControllerFindAll401 | TemplatesControllerFindAll403>, TemplatesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templatesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all checklist templates
 * {@link /api/v1/checklist-templates}
 */
export function useTemplatesControllerFindAll<TData = TemplatesControllerFindAllQueryResponse, TQueryData = TemplatesControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplatesControllerFindAllQueryKey>(params?: TemplatesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplatesControllerFindAllQueryResponse, ResponseErrorConfig<TemplatesControllerFindAll401 | TemplatesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templatesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templatesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplatesControllerFindAll401 | TemplatesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}